export class CancelError extends Error {
  constructor() {
    super('Cancelled');
  }
}

export default CancelError;
